import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Box, Button, Grid, Link, Typography } from '@material-ui/core';

import DenunciaImg from '../../../../assets/img/denuncia_new.svg';
// import DenunciaImg from '../../../../assets/img/denuncia.png';
import ErrorImg from '../../../../assets/img/ic_error.png';
import {
  incidentRoad,
  original_crash,
} from '../../../../constants/incidents.constant';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';
import { useTipification } from '../../../../hooks/useTipification';
import { useSinisterStore } from '../../../../stores/Sinister/sinister.store';

const FinishStep = () => {
  const { success, errors, sinister_body, updateSinisterBody } =
    useSinisterDataContext();
  const history = useHistory();
  const { user, embed } = useAuthDataContext();
  const { trackEvent, events } = useTipification();

  const handleIncidents = () => {
    history.push('/account/incidents');
    incidentRoad.crash = original_crash.crash;
  };

  const handleHome = () => {
    embed
      ? window.parent.postMessage({ return: 'overview' }, '*')
      : history.push('/dashboard');
    incidentRoad.crash = original_crash.crash;
  };

  const handleAssistance = () => {
    history.push({
      pathname: '/assistance',
      state: { vehicle_id: sinister_body.id },
    });
    incidentRoad.crash = original_crash.crash;
  };

  useEffect(() => {
    return () => {
      updateSinisterBody('');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (success.sinister) trackEvent(events.ADD_CLAIM, success.sinister?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.sinister, trackEvent, events]);

  const sinisterType = useSinisterStore((state) => state.sinisterType);

  return success.sinister || errors.sinister?.status === 409 ? (
    <Grid container>
      <Grid container justify="center">
        <Grid item xs={12}>
          <Box
            my={6}
            alignItems="center"
            justifyContent="center"
            display="flex"
          >
            <img src={DenunciaImg} alt={'denuncia'}></img>
          </Box>
          <Box alignItems="center" justifyContent="center" display="flex">
            <Typography variant="caption">
              Número de seguimiento: {`#${success.sinister?.id}`}{' '}
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} justify="center">
          <Box
            my={4}
            alignItems="center"
            justifyContent="center"
            display="flex"
          >
            <Typography variant="h6" color="textPrimary">
              {errors.sinister?.status === 409
                ? '¡Tu denuncia fue registrada anteriormente!'
                : '¡Ya estamos revisando tu denuncia!'}
            </Typography>
          </Box>
          <Box
            my={4}
            alignItems="center"
            justifyContent="center"
            display="flex"
          >
            <Typography>
              {sinisterType && sinisterType === 'partial_robbery' ? (
                <Box my={4}>
                  Tené en cuenta que cuando vayas a buscar el reemplazo del
                  elemento que te hayan robado,{' '}
                  <strong>
                    vas a tener que presentar la denuncia policial.
                  </strong>
                </Box>
              ) : (
                'Te informaremos en cuanto haya un avance en el proceso.'
              )}
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid container justify="center">
        <Grid item xs={12} sm={6}>
          <Box my={4}>
            {' '}
            {/* Ver denuncia */}
            <Button
              onClick={handleIncidents}
              variant="contained"
              color="primary"
              fullWidth={true}
            >
              Ver denuncia
            </Button>
          </Box>

          {sinister_body.need_assistance && (
            <Box>
              {' '}
              {/* Continuar con la asistencia */}
              <Button
                onClick={handleAssistance}
                variant="contained"
                color="primary"
                fullWidth={true}
              >
                Continuar con la asistencia
              </Button>
            </Box>
          )}

          <Box my={4}>
            {' '}
            {/* Ver Denuncia */}
            <Button
              onClick={handleHome}
              variant="outlined"
              color="primary"
              fullWidth={true}
            >
              Volver al inicio
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  ) : (
    <Grid container>
      <Grid container justify="center">
        <Grid item xs={12}>
          <Box
            my={6}
            alignItems="center"
            justifyContent="center"
            display="flex"
          >
            <img src={ErrorImg} width={195} height={190} alt={'error'}></img>
          </Box>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12} justify="center">
          <Box
            my={4}
            alignItems="center"
            justifyContent="center"
            display="flex"
          >
            <Typography variant="h6" color="primary">
              Parece que ha habido un error
            </Typography>
          </Box>
          <Box
            my={4}
            alignItems="center"
            justifyContent="center"
            display="flex"
          >
            <Typography>No se pudo solicitar tu denuncia</Typography>
          </Box>
          <Box alignItems="center" justifyContent="center" display="flex">
            <Typography>
              Puedes llamar al siguiente número para más información:
            </Typography>
          </Box>
          {user.company === 'answer' ? (
            <Box
              alignItems="center"
              justifyContent="center"
              display="flex"
              flexWrap="wrap"
              flexDirection="column"
            >
              <Typography align="left">Teléfono</Typography>
              <Link href={'tel:43198800'} rel="noopener" target="_blank">
                <Typography align="left" color="secondary">
                  CABA / GBA: 4319-8800
                </Typography>
              </Link>
              <Link href={'tel:08004440352'} rel="noopener" target="_blank">
                <Typography align="left" color="secondary">
                  INTERIOR: 0800-444-0352
                </Typography>
              </Link>
            </Box>
          ) : (
            <Box
              alignItems="center"
              justifyContent="center"
              display="flex"
              flexWrap="wrap"
              flexDirection="column"
            >
              <Typography align="left">Teléfono</Typography>
              <Link href={'tel:43390000'} rel="noopener" target="_blank">
                <Typography align="left" color="secondary">
                  CABA / GBA: 4339-0000
                </Typography>
              </Link>
              <Link href={'tel:08002222772'} rel="noopener" target="_blank">
                <Typography align="left" color="secondary">
                  INTERIOR: 0800-2222-772
                </Typography>
              </Link>
            </Box>
          )}
        </Grid>
      </Grid>
      <Grid container justify="center">
        <Grid item xs={12} sm={6}>
          <Box my={4}>
            <Link href={'tel:08002222772'} rel="noopener" target="_blank">
              <Button variant="outlined" color="secondary" fullWidth>
                Llamar por teléfono
              </Button>
            </Link>
          </Box>
          <Box my={4}>
            <Button
              onClick={handleIncidents}
              variant="contained"
              color="primary"
              fullWidth
            >
              Volver a intentar
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FinishStep;
